// Third-Party
import { Stack } from "@mui/material";

// Internal
import { RHFTextField } from "@components/hook-form";

export interface IAskDostOdooConnectDialogContentProps {
  translate: (text: string, options?: any) => string;
}

export const AskDostOdooConnectDialogContent: React.FC<
  IAskDostOdooConnectDialogContentProps
> = ({ translate }) => {
  return (
    <Stack spacing={2.25}>
      <RHFTextField
        name="odooUrl"
        label={translate("odoo_url")}
        placeholder="https://mycompany.odoo.com"
        size="small"
        fullWidth
      />
      <RHFTextField
        name="username"
        label={translate("username")}
        placeholder="abc@mydost.ai"
        size="small"
        fullWidth
      />
      <RHFTextField
        name="apiKey"
        label={translate("api_key_or_password")}
        type="password"
        size="small"
        fullWidth
      />
      <RHFTextField
        name="dbName"
        label={translate("database_name_optional")}
        placeholder="mycompany"
        size="small"
        fullWidth
      />
    </Stack>
  );
};
